import { useEffect, useMemo, useState } from "react";
import { AppSettings, defaultSettings } from "./settings.schema";
import { watchTeamSettings } from "./settings.service";

export function useTeamSettings(teamId: string) {
  const [settings, setSettings] = useState<AppSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!teamId) return;
    setLoading(true);
    const unsub = watchTeamSettings(teamId, (s) => {
      setSettings(s ?? defaultSettings(teamId));
      setLoading(false);
    });
    return () => unsub();
  }, [teamId]);

  const safe = useMemo(() => settings ?? defaultSettings(teamId), [settings, teamId]);
  return { settings: safe, loading, error };
}
